import React from 'react'
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Row, Col, Grid, Space, Button, Typography, Image } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import Portal from '../../assets/img/domestic/portal.png';
// import CButton from '../../components/Button';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function GetBreakPoint() {
  const screens = useBreakpoint()
  return screens;
}

export  function cta(props) {
  const { xs, md, sm } = GetBreakPoint()
  const { t } = props
  
  return (
    <React.Fragment>
      <Row style={{ width: '100%', backgroundColor: '#fff', paddingBottom: md ? 32 : 16 }}>
        <Col xs={{ span: 22, offset: 1 }} md={{ span: 18, offset: 3 }} xxl={{ span: 14, offset: 5 }}>
          {
            md || sm ?
              <Row justify="space-around" align="middle">
                <Col span={12}>
                  <Image
                    width={ xs || sm ? '100%' : 400 }
                    src={Portal}
                    preview={false}
                  />
                </Col>
                <Col span={12}>
                  <Space direction="vertical" size={32}>
                    <Space direction='vertical' size={0}>
                      <Text>
                        <Text className="dark-color" style={{ fontSize: 28, fontWeight: 'bold', lineHeight: 1.2 }}>{t('jobDomestic.want')} </Text>
                        <Text className="primary-color" style={{ fontSize: 28, fontWeight: 'bold', lineHeight: 1.2 }}>{t('jobDomestic.income')} </Text>
                        <Text className="primary-color" style={{ fontSize: 32, fontWeight: 'bold', lineHeight: 1.2 }}>5x</Text>
                      </Text>
                      <Text className="dark-color" style={{ fontSize: 28, fontWeight: 'bold', lineHeight: 1.2 }}>{t('jobDomestic.bigger')}</Text>
                    </Space>
                    <Text className="dark-color" style={{ fontSize: 18, fontWeight: 'normal', lineHeight: 1.2 }}>{t('jobDomestic.title1')}</Text>
                    <Link className="width-100 text-align-center" to="/international">
                      <Button className="box-shadow text-align-center" type="primary" style={{ border: '#4273b9', background: '#4273b9', borderRadius: 32, height: 50, boxShadow: '0px 4px 6px rgb(70 103 152 / 1)', fontSize: 20, fontWeight: 500 }}>{t('jobDomestic.jobPortal')} <ArrowRightOutlined /></Button>
                    </Link>
                  </Space>
                </Col>
              </Row>
            :
              <Row justify="space-around" align="middle" gutter={ md ? [0, 32] : [0, 8]}>
                <Col span={24}>
                  <Space direction="vertical" size={32}>
                    <Space direction='vertical' size={0}>
                      <Text>
                        <Text className="dark-color" style={{ fontSize: 28, fontWeight: 'bold', lineHeight: 1.2 }}>{t('jobDomestic.want')} </Text>
                        <Text className="primary-color" style={{ fontSize: 28, fontWeight: 'bold', lineHeight: 1.2 }}>{t('jobDomestic.incom')} </Text>
                        <Text className="primary-color" style={{ fontSize: 32, fontWeight: 'bold', lineHeight: 1.2 }}>5x</Text>
                      </Text>
                      <Text className="dark-color" style={{ fontSize: 28, fontWeight: 'bold', lineHeight: 1.2 }}>{t('jobDomestic.bigger')}</Text>
                    </Space>
                    <Text className="dark-color" style={{ fontSize: 18, fontWeight: 'normal', lineHeight: 1.2 }}>{t('jobDomestic.title1')}</Text>
                  </Space>
                </Col>
                <Col span={24}>
                  <Image
                    width={'100%'}
                    src={Portal}
                    preview={false}
                  />
                </Col>
                <Col span={24}>
                  <Link className="width-100 text-align-center" to="/international">
                    <Button className="box-shadow text-align-center" type="primary" style={{ border: '#4273b9', background: '#4273b9', borderRadius: 32, height: 40, width: '100%', boxShadow: '0px 4px 6px rgb(70 103 152 / 1)' }}>{t('jobDomestic.jobPortal')} <ArrowRightOutlined /></Button>
                    {/* <CButton className="box-shadow text-align-center" type="primary-icon" style={{ border: '#4273b9', background: '#4273b9', borderRadius: 32, height: 40, width: '100%', boxShadow: '0px 4px 6px rgb(70 103 152 / 1)' }} title={t('jobDomestic.jobPortal')} icon="ArrowRightOutlined" /> */}
                  </Link></Col>
              </Row>
          }
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default withTranslation()(cta)
